import { slice } from './slice';

const { reducer } = slice;

export * from './thunks';
export * as catalogsSelectors from './selectors';

export default reducer;
